





















































































































































































































import { AxiosError } from 'axios';
import { mapActions, mapGetters, mapState } from 'vuex';
import { PropType } from 'vue';

import { updateStreamer, validateStreamer } from '@/api/CopyStake/Streamers';
import {
  TStreamer,
  EStreamerType,
  EStreamingType,
  EStreamerCategory
} from '@/api/schema';

import * as vr from '@/helpers/validation';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { LANGUAGES } from '@/helpers/langHelpers';
import { objectToBlob } from '@/helpers/blobHelper';

export default {
  name: 'CopyStakeStreamerEditDialog',
  props: {
    value: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    },
    streamer: {
      type: Object as PropType<TStreamer>,
      default: null
    }
  },
  data(): any {
    return {
      streamerTypes: [
        { value: EStreamerType.PRIVATE, label: 'Private' },
        { value: EStreamerType.PUBLIC, label: 'Public' }
      ],
      streamerCategories: [
        { value: EStreamerCategory.SLOTS, label: 'Slots' },
        { value: EStreamerCategory.LIVE_CASINO, label: 'Live Casino' },
        { value: EStreamerCategory.TABLE_GAMES, label: 'Table Games' },
        { value: EStreamerCategory.CRASH_GAMES, label: 'Crash Games' },
        { value: EStreamerCategory.INSTANT_WIN, label: 'Instant Win' },
        { value: EStreamerCategory.GAME_SHOWS, label: 'Game Shows' },
        { value: EStreamerCategory.VIRTUAL_SPORTS, label: 'Virtual Sports' },
        { value: EStreamerCategory.SPORTSBOOK, label: 'Sportsbook' },
        { value: EStreamerCategory.POKER, label: 'Poker' },
        { value: EStreamerCategory.ARCADE_GAMES, label: 'Arcade Games' },
        {
          value: EStreamerCategory.SKILL_BASED_GAMES,
          label: 'Skill Based Games'
        }
      ],

      formData: {
        nickname: '',
        operatorUserId: '',
        accessCode: '',
        type: '',
        language: '',
        shortBio: '',
        categories: [],
        socialLinks: {
          TWITCH: '',
          YOUTUBE: '',
          INSTAGRAM: '',
          TWITTER: '',
          FACEBOOK: '',
          TIKTOK: '',
          DISCORD: '',
          KICK: ''
        }
      },

      serverError: {
        nickname: null,
        accessCode: null,
        operatorUserId: null,
        type: null,
        streamingType: null,
        language: null,
        shortBio: null,
        categories: null,
        socialLinks: null
      },

      processing: false,
      formValid: false
    };
  },
  watch: {
    async value(val: boolean): Promise<void> {
      if (val) {
        await this.resetForm();

        if (!!this.streamer && !!Object.keys(this.streamer).length) {
          this.formData = {
            ...this.streamer,
            categories: this.streamer.categories ?? [],
            socialLinks: {
              TWITCH: this.streamer.socialLinks?.TWITCH ?? '',
              YOUTUBE: this.streamer.socialLinks?.YOUTUBE ?? '',
              INSTAGRAM: this.streamer.socialLinks?.INSTAGRAM ?? '',
              TWITTER: this.streamer.socialLinks?.TWITTER ?? '',
              FACEBOOK: this.streamer.socialLinks?.FACEBOOK ?? '',
              TIKTOK: this.streamer.socialLinks?.TIKTOK ?? '',
              DISCORD: this.streamer.socialLinks?.DISCORD ?? '',
              KICK: this.streamer.socialLinks?.KICK ?? ''
            }
          };
        }
      }
    },
    operatorId: {
      handler(id: number): void {
        if (id) {
          this.getOperatorLanguages();
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('Operator', ['languages']),
    ...mapGetters('Onboarding', ['operatorId']),
    isDialogVisible: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      }
    },
    rules(): any {
      return {
        nickname: [
          vr.required,
          (v: string) => vr.maxLength(v, 20),
          (v: string) =>
            vr.validByRegExp(
              v,
              /^[A-Za-z0-9\s_.-]{2,20}$/,
              'Only latin letters, number, blank space and symbols ( - _ . ) available'
            )
        ],
        operatorUserId: [vr.required],
        accessCode: [
          (v: string) => {
            if (this.formData.type === EStreamerType.PRIVATE) {
              return vr.required(v);
            }

            return true;
          },
          (v: string) => {
            if (!v) return true;

            return !v.includes(' ') || 'No blank space available';
          },
          (v: string) => {
            if (!v) return true;

            return vr.validByRegExp(
              v,
              /^[0-9A-Z]{6}$/i,
              'Access code field must contains only numbers and A-Z'
            );
          },
          (v: string) => {
            if (!v) return true;

            return vr.minLength(v, 6);
          },
          (v: string) => {
            if (!v) return true;

            return vr.maxLength(v, 6);
          }
        ],
        type: [vr.required],
        language: [vr.required],
        shortBio: [
          (v: string) => {
            if (!v) return true;

            return vr.maxLength(v, 140);
          }
        ],
        categories: [],
        socialLinks: {
          TWITCH: [
            (v: string) => {
              if (!v) return true;

              return vr.url(v);
            }
          ],
          YOUTUBE: [
            (v: string) => {
              if (!v) return true;

              return vr.url(v);
            }
          ],
          INSTAGRAM: [
            (v: string) => {
              if (!v) return true;

              return vr.url(v);
            }
          ],
          TWITTER: [
            (v: string) => {
              if (!v) return true;

              return vr.url(v);
            }
          ],
          FACEBOOK: [
            (v: string) => {
              if (!v) return true;

              return vr.url(v);
            }
          ],
          TIKTOK: [
            (v) => {
              if (!v) return true;

              return vr.url(v);
            }
          ],
          DISCORD: [
            (v: string) => {
              if (!v) return true;

              return vr.url(v);
            }
          ],
          KICK: [
            (v: string) => {
              if (!v) return true;

              return vr.url(v);
            }
          ]
        }
      };
    },
    isEdit(): boolean {
      return !!this.streamer?.id;
    },
    header(): string {
      return this.isEdit ? 'Edit Streamer' : 'New Streamer';
    },
    submitText(): string {
      return this.isEdit ? 'Save' : 'Next';
    },
    operatorLanguages(): any {
      return LANGUAGES.filter((lang) => this.languages.includes(lang.value));
    }
  },
  methods: {
    ...mapActions('Operator', ['getOperatorLanguages']),
    async handlerOnSubmit(): Promise<void> {
      try {
        this.resetServerErrors();
        await this.$refs.form.validate();

        if (!this.formValid || this.processing) return;
        this.processing = true;

        const payload = {
          ...this.formData,
          accessCode:
            (this.formData.accessCode &&
              this.formData.accessCode.toUpperCase()) ||
            null,
          streamingType: EStreamingType.WHIP,
          operatorId: this.operatorId,
          socialLinks: Object.fromEntries(
            Object.entries(this.formData.socialLinks).filter(
              ([key, value]) => !!value
            )
          )
        };

        let streamerData: TStreamer;

        if (this.isEdit) {
          const formData = new FormData();

          formData.append('streamer', objectToBlob(payload));

          streamerData = await updateStreamer(this.streamer.id, formData);

          this.$toast.success(
            `Streamer "${this.streamer.nickname}" has been successfully updated`
          );
        } else {
          await validateStreamer(payload);

          streamerData = payload;
        }

        this.closeDialog(this.isEdit);

        this.$emit('submit', {
          isEdit: this.isEdit,
          streamer: streamerData
        });
      } catch (error) {
        this.parseServerErrors(error);
        errorToastMessage(error);
      } finally {
        this.processing = false;
      }
    },
    parseServerErrors(error: AxiosError): void {
      if (error instanceof AxiosError) {
        const errorMessage = error.response?.data?.message;
        if (!errorMessage) return;

        if (
          errorMessage.includes('Streamer with access code') ||
          errorMessage.includes('Streamer with accessCode')
        ) {
          this.serverError.accessCode = errorMessage;
        }

        if (errorMessage.includes('Streamer with nickname')) {
          this.serverError.nickname = errorMessage;
        }

        if (errorMessage.includes('Streamer with user')) {
          this.serverError.operatorUserId = errorMessage;
        }

        if (errorMessage.includes('User by operatorUserId')) {
          this.serverError.operatorUserId = errorMessage;
        }

        if (errorMessage.includes('streaming-type')) {
          this.serverError.streamingType = errorMessage;
        }

        if (errorMessage.includes('shortBio')) {
          this.serverError.shortBio = errorMessage;
        }

        if (errorMessage.includes('categories')) {
          this.serverError.categories = errorMessage;
        }
      }
    },
    closeDialog(clearData: boolean = true): void {
      this.isDialogVisible = false;
      this.$emit('close', clearData);
    },
    resetServerErrors(): void {
      this.serverError = {
        nickname: null,
        accessCode: null,
        operatorUserId: null,
        type: null,
        streamingType: null,
        language: null,
        shortBio: null,
        categories: null,
        socialLinks: null
      };
    },
    async resetForm(): Promise<void> {
      this.formData = {
        nickname: '',
        operatorUserId: '',
        accessCode: '',
        type: '',
        language: '',
        shortBio: '',
        categories: [],
        socialLinks: {
          TWITCH: '',
          YOUTUBE: '',
          INSTAGRAM: '',
          TWITTER: '',
          FACEBOOK: '',
          TIKTOK: '',
          DISCORD: '',
          KICK: ''
        }
      };

      this.resetServerErrors();
      await this.$refs.form?.reset();
    }
  }
};
